// extracted by mini-css-extract-plugin
export default {"noOverflow":"surveypage_noOverflow__6wS56","surveyPage":"surveypage_surveyPage__-uaby","bg":"surveypage_bg__w2hl8","infoButton":"surveypage_infoButton__FJsSg"};